import { isEmpty } from 'ramda'

import { ADDRESS_STEPS } from '../screens/HomeDelivery/components'
import type { ClientDataAddress } from '../typings'

export const getNextAddressRoute = (address: ClientDataAddress) => {
  return ADDRESS_STEPS.filter((step) =>
    isEmpty(address[step.name as keyof typeof address])
  )
}
